import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { NumberInput } from "@/lib/Components/Form/Inputs/NumberInput";
import { PhoneInput } from "@/lib/Components/Form/Inputs/PhoneInput";
import { DateInput } from "@/lib/Components/Form/Inputs/DateInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateBookingMutation } from "@/app/Bookings/GraphQL/bookingMutations";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useBooking } from "@/app/Bookings/Hooks/useBooking";
import { BookingGenderInput } from "@/app/Bookings/Forms/BookingGenderInput";
import { bookingMessages } from "@/app/Bookings/Messages/bookingMessages";

export function BookingEditCustomerDetailsDialog({
  bookingId,
}: {
  bookingId: string;
}) {
  const record = useBooking(bookingId);
  const { mutateAsync } = useGqlMutation(updateBookingMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title="Edit Customer Details">
      <GenericForm
        initialValues={{
          name: record.name,
          email: record.email,
          phone: record.phone,
          date_of_birth: record.date_of_birth,
          number_of_travellers: record.number_of_travellers,
          address: record.address,
          gender: record.gender,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: record.id,
            input: values,
          });

          return close();
        }}
      >
        <TextInput
          name={"name"}
          label={"Name"}
          className="col-span-4"
          autoFocus
        />
        <NumberInput
          className="col-span-4"
          name={"number_of_travellers"}
          label={"Number of travellers"}
        />

        <TextInput name={"email"} label={"Email"} className="col-span-4" />
        <PhoneInput
          name={"phone"}
          label={"Phone"}
          className="col-span-4"
          defaultRegion={record.departureOffice.city.region}
        />
        <DateInput
          name={"date_of_birth"}
          label={"Date of Birth"}
          calendarProps={{
            captionLayout: "dropdown",
            startMonth: new Date(1900, 0),
            endMonth: new Date(new Date().getFullYear() - 18, 11),
          }}
          className="col-span-4"
        />

        {record.supplier.collect_gender_on_bookings ? (
          <BookingGenderInput
            name={"gender"}
            label={bookingMessages.genderLabel}
            className="col-span-4"
          />
        ) : null}

        {record.supplier.collect_address_on_bookings ? (
          <TextAreaInput
            name={"address"}
            label={"Address"}
            className="col-span-full"
          />
        ) : null}

        <DialogSubmitButton text={"Update customer details"} />
      </GenericForm>
    </BaseDialog>
  );
}
